import { normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4d1b99ba"),n=n(),_popScopeId(),n)
const _hoisted_1 = { id: "content" }
const _hoisted_2 = { id: "copyable-text-section" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      id: "color-preview",
      style: _normalizeStyle(_ctx.colorPreviewStyle)
    }, null, 4),
    _createElementVNode("div", _hoisted_2, [
      (_ctx.currentName)
        ? (_openBlock(), _createElementBlock("button", {
            key: 0,
            class: "copyable-text",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('namePress')))
          }, " 📋 Name: " + _toDisplayString(_ctx.currentName), 1))
        : _createCommentVNode("", true),
      (_ctx.currentTag)
        ? (_openBlock(), _createElementBlock("button", {
            key: 1,
            class: "copyable-text",
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('tagPress')))
          }, " 📋 Tag: " + _toDisplayString(_ctx.currentTag), 1))
        : _createCommentVNode("", true),
      _createElementVNode("button", {
        class: "copyable-text",
        onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('hexPress')))
      }, " 📋 Hex: " + _toDisplayString(_ctx.currentHex), 1),
      _createElementVNode("button", {
        class: "copyable-text",
        onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.$emit('rgbPress')))
      }, " 📋 RGB: " + _toDisplayString(_ctx.currentRGB), 1)
    ])
  ]))
}